<template>
  <b-modal id="address-modal" title="FUB Addresses" hide-footer>
    <div>
      <p class="text-center">It looks like you are pulling information from Follow Up Boss. Would you like to select one of these addresses?</p>
      <b-list-group v-if="person">
        <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="address in person.addresses" :key="address.id">
          <div>{{ address.street }} {{ address.city }}, {{ address.state }} {{ address.code }}</div>
          <b-button size="sm" variant="success" @click="$emit('fillAddress', address)">Select</b-button>
        </b-list-group-item>
      </b-list-group>
      <div class="text-center mt-4">
        <b-button variant="danger" @click="closeModal">Add Address Myself</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    person: null
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('address-modal');
    }
  }
};
</script>